export interface IntegrationConnectionStatusProps {
  connected: boolean;
  status: string | null;
}

export const IntegrationConnectionStatus = ({
  connected,
  status,
}: Readonly<IntegrationConnectionStatusProps>) => {
  const statusText = (() => {
    if (connected) return "Connected";
    if (status === null) return "Not connected";
    return status;
  })();

  const statusColor = (() => {
    if (connected) return "bg-green-500";
    if (status) return "bg-orange-500";
    return "bg-slate-400";
  })();
  const capitalizedStatusText =
    statusText.charAt(0).toUpperCase() + statusText.slice(1);

  return (
    <div className="flex items-center space-x-2">
      <div className={`h-3 w-3 rounded-full ${statusColor}`} />
      <div>{capitalizedStatusText}</div>
    </div>
  );
};
